import React from "react";
import "./priorityBeam.scss";

type buttonProps = {
  className?: any;
};

type buttonState = {

};
class PriorityBeam extends React.Component<buttonProps, buttonState> {

  constructor(props: any) {
    super(props);
    this.state = {

    };
  }

  render() {
    return (
      <>
        <span className={this.props.className}></span>
      </>
    );
  }

}

export {
  PriorityBeam
};

